<template>
    <div class="login_container">
        <div class="login_wrap">
            <div class="tit">
                <h1 class="icon_wrap"><img src="img/logo_w.png" alt="반성매매 시민참여 플랫폼" /></h1>
                <p>
                    <img src="img/setting_icon.png" alt="관리자 로그인" />
                    관리자 로그인
                </p>
            </div>

            <input type="text" v-model="state.username" v-on:keyup.enter="login" placeholder="아이디" />
            <input type="password" v-model="state.password" v-on:keyup.enter="login" placeholder="비밀번호" />
            <button type="button" @click="login">로그인</button>
        </div>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        useI18n,
        userStore,
        apiService,
        reactive,
        router,
        onMounted,
        ModalDefault,
        globalStore,
        watch,
        types,
        useRoute,
        getMessageByCode,
        CommonUtils,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { ModalDefault },
        setup() {
            const user = userStore();
            const global = globalStore();
            const route = useRoute();
            const state = reactive({
                placeholdID: "",
                placeholdPW: "",
                username: "",
                password: "",
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                modalYes: "확인" as string,

                redirectUrl: "" as any,
            });

            const state2 = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                modalYes: "확인" as string,
            });

            onMounted(() => {
                user.$reset();

                if (route.query.redirect) state.redirectUrl = route.query.redirect;
            });
            const t = useI18n();
            const login = async () => {
                const param: types.ReqLogin = {
                    id: state.username,
                    pw: state.password,
                };
                let res: types.ResCommon = await apiService.auth.login(param);

                if (res.returnCode === 0) {
                    let res2: types.ResUserInfo = await apiService.auth.mypageMe();
                    if (res2.returnCode === 0) {
                        user.setInfo({
                            id: res2.data.memberVO.id,
                            idx: res2.data.memberVO.idx,
                            name: res2.data.memberVO.name,
                            isAdmin: res2.data.memberVO.gubun !== 3,
                            gubun: res2.data.memberVO.gubun,
                        });
                        user.setRole(res2.data.roleVO);
                        if (state.redirectUrl) router.replace(state.redirectUrl);
                        else router.replace("/");
                    } else if (res2.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res2.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "사용자를 찾을 수 없습니다.";
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const openModal = (tab: number, isResult: boolean) => {
                state.modalTab = tab;
                state.isShowModal = true;
                state.modalIsResult = isResult;
            };

            const callBackModal = async (param: any) => {};

            const closeModal2 = () => {
                state2.isShowModal = false;
                state2.modalTab = -1;
            };

            const callBackModal2 = async (param: any) => {};

            return {
                state,
                state2,
                login,
                router,
                closeModal,
                openModal,
                callBackModal,
                closeModal2,
                callBackModal2,
            };
        },
    };
</script>
